// store this in a separate file, to avoid importing query client and axios in pixie

let activeWorkspaceId = 0;
let activeWorkspaceEncrypted = false;

// for access outside react
export function getActiveWorkspaceId() {
  return activeWorkspaceId;
}

export function setActiveWorkspaceId(id: number) {
  activeWorkspaceId = id;
}

export function getActiveWorkspaceEncrypted(): boolean {
  return activeWorkspaceEncrypted;
}

export function setActiveWorkspaceEncrypted(value: boolean) {
  activeWorkspaceEncrypted = value;
}
